
































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Button, Form } from 'element-ui';
import AssignFollowers from '@/components/modals/inquiry/AssignFollowers.vue';
import CustomerDetails from '@/components/inquiry/new/CustomerDetails.vue';
import UpsertCargo from '@/components/inquiry/upserts/Cargo.vue';
import UpsertExtra from '@/components/inquiry/upserts/Extra.vue';
import UpsertRoute from '@/components/inquiry/upserts/Route.vue';
import UpsertTransaction from '@/components/inquiry/upserts/Transaction.vue';

import { inquiryService } from '@/services/InquiryService';

// gql
import FetchCopyOfInquiry from '@/graphql/queries/FetchCopyOfInquiry.gql';
import submitInquiry from '@/graphql/mutations/SubmitInquiry.gql';

// Types
import {
  CargoDescriptionInput,
  CargoTypeEnum,
  CustomerFields,
  CustomerRoleEnum,
  IncotermsTypeEnum,
  InquiryFields,
  InquiryInput,
  PlaceFields,
  TransportationTypeEnum
} from '@/types/graphql/schemaTypes';

import { i18n } from '@/plugins/i18n';
import get from 'lodash/get';

@Component({
  apollo: {
    originInquiry: {
      query: FetchCopyOfInquiry,
      skip() {
        return !this.$route.params.id;
      },
      prefetch: true,
      variables() {
        return {
          inquiryArgs: {
            inquiryId: this.$route.params.id
          }
        };
      },
      error(error) {
        this.error = true;
      },
      update(data) {
        if (data) {
          this.shipperDetails = {
            id: data.inquiries[0].id,
            customerOrganization: {
              id: data.inquiries[0].customerOrganization.id
            }
          };
        }
        return data && data.inquiries[0];
      },
      fetchPolicy: 'cache-and-network'
    }
  },
  components: {
    AssignFollowers,
    CustomerDetails,
    UpsertCargo,
    UpsertExtra,
    UpsertRoute,
    UpsertTransaction,
    'el-button': Button,
    'el-form': Form
  }
})
export default class InquiryForm extends Vue {
  private arrivalValid = true;
  private departureValid = true;
  public inquiryInput: InquiryInput = {
    arrivalCustomerLocationId: null,
    blMetaData: {
      blNumber: null,
      blType: null,
      houseBlNumber: null,
      issueDate: null,
      issuePlace: null,
      numberOfCopy: null,
      numberOfOriginal: null
    },

    cargoDescription: {
      description: null,
      containers: [
        {
          contentNetWeight: null,
          requestedContainerCount: null,
          requestedContainerType: null
        }
      ],
      parcels: [
        {
          length: null,
          width: null,
          height: null,
          netWeight: null,
          packagingType: 'BX',
          quantity: null
        }
      ]
    },
    cargoInsurance: null,
    cargoType: null,
    customerReference: '',
    customerRole: CustomerRoleEnum.seller,
    customsHandling: null,
    departureCustomerLocationId: null,
    incoterm: '',
    transportationType: TransportationTypeEnum.any
  };

  public regulated = false;
  public shipperDetails = null;
  private loading = false;
  private error = false;
  private originInquiry: InquiryFields | null = null;
  private shipperIds: string[] = [];
  private openFollowers = false;

  private rules = {
    incoterm: [
      {
        validator: this.incotermsValidation,
        required: true,
        message: i18n.t('validation.required'),
        trigger: 'change'
      }
    ]
  };

  public arrivalPlace: PlaceFields | null = null;
  public departurePlace: PlaceFields | null = null;

  $refs!: {
    quoteForm: HTMLFormElement;
  };

  get customerOrganization() {
    return this.shipperDetails?.customerOrganization;
  }

  private incotermsValidation(rule: any, value: any, callback: any) {
    // check if incoterms is not default value '' or invalid incotermEnum
    if (value === '' && !IncotermsTypeEnum[value]) {
      callback(new Error());
    } else {
      callback();
    }
  }

  // custome validation for address
  private addressValid() {
    this.departureValid =
      !!this.inquiryInput.departureCustomerLocationId ||
      !!this.inquiryInput.departurePlaceId;
    this.arrivalValid =
      !!this.inquiryInput.arrivalCustomerLocationId ||
      !!this.inquiryInput.arrivalPlaceId;
  }

  private handleFollowerModal() {
    // check the form validity
    this.$refs.quoteForm.validate((elValid: boolean) => {
      if (elValid && this.departureValid && this.arrivalValid) {
        // if form is valid open follower modal
        this.openFollowers = true;
      } else {
        this.$nextTick(() => {
          const element: HTMLElement = this.$refs.quoteForm.$el.querySelector(
            '.el-form-item__error'
          ).parentElement;

          // scroll to first input with error
          if (element.parentElement) {
            element.parentElement.scrollIntoView();
          }
        });
      }
    });
  }

  async submit() {
    this.openFollowers = false;
    this.$refs.quoteForm.validate(async(elValid: boolean) => {
      this.addressValid();
      if (elValid && this.departureValid && this.arrivalValid) {
        /**
         * cargoDescription is shared in 2 components
         * keep value regulated in sync by extracting if from object
         */
        if (this.inquiryInput.cargoDescription) {
          this.inquiryInput.cargoDescription.regulated = this.regulated;
        }

        try {
          this.loading = true;
          const response = await this.$apollo.mutate({
            mutation: submitInquiry,
            variables: {
              inquiryArgs: this.inquiryInput,
              organizationId: this.customerOrganization.id,
              originalInquiryId: this.originInquiry
                ? this.originInquiry.id
                : undefined,
              shipperIds: this.shipperIds ? this.shipperIds : undefined
            }
          });
          if (response) {
            this.$router.push({
              name: 'inquiryDetails',
              params: { id: response.data.submitInquiry.id }
            });
            this.$store.dispatch('Alert/addAlert', {
              type: 'success',
              message: this.$t('success.submitted'),
              time: 2000
            });
          }
        } catch (error) {
          this.$store.dispatch('Alert/addAlert', {
            type: 'error',
            message: this.$t('error.push'),
            time: 2000
          });
        } finally {
          this.loading = false;
        }
      } else {
        this.$nextTick(() => {
          const element: HTMLElement = this.$refs.quoteForm.$el.querySelector(
            '.el-form-item__error'
          ).parentElement;

          // scroll to first input with error
          if (element.parentElement) {
            element.parentElement.scrollIntoView();
          }
        });
      }
    });
  }

  private updateInquiryInput(inquiryInput: InquiryInput) {
    this.inquiryInput = { ...this.inquiryInput, ...inquiryInput };
  }

  private updateFollower(followers: string[]) {
    this.shipperIds = followers;
    this.submit();
  }

  get hasQuote() {
    return !!this.$store.state.Inquiry.quote;
  }
}
